export const isRunningAsElectronApp = () => {
  return (window && window.process && window.process.type !== undefined)
}

export const isRunningAsLocalSite = () => {
  return (process.env.NODE_ENV === 'development' && !isRunningAsElectronApp())
}



// WEBPACK FOOTER //
// ./src/lib/environmentUtils.js